import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

/*
|-------------------------------------------------------------------------------
| Select Controller
|-------------------------------------------------------------------------------
|
| The following component consumes the state and actions from a parent Select
| Container, and gives it to it's child as props.
|
| It can be used to wrap any kind of Select component:
|
|  - Input
|  - Menu
|
*/

/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { SelectModelPropType } from '../utils/custom-prop-types';
import { SELECT_MODEL } from './select';

function selectController(WrappedComponent) {
  var name = "selectCtrl(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");

  var SelectController =
  /*#__PURE__*/
  function (_Component) {
    _inherits(SelectController, _Component);

    function SelectController() {
      _classCallCheck(this, SelectController);

      return _possibleConstructorReturn(this, _getPrototypeOf(SelectController).apply(this, arguments));
    }

    _createClass(SelectController, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!this.context[SELECT_MODEL]) {
          var _context;

          console.warn(_concatInstanceProperty(_context = "\"".concat(name, "\" was used without a parent Select component.\nAdd the \"", '<Select />', "\" component anywhere above \"")).call(_context, name, "\"."));
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(WrappedComponent, _extends({}, this.props, {
          select: this.context[SELECT_MODEL]
        }));
      }
    }]);

    return SelectController;
  }(Component); // NOTE: We go ahead and hoist prop types, so tools like Storybook work nicely.


  _defineProperty(SelectController, "contextTypes", _defineProperty({}, SELECT_MODEL, SelectModelPropType));

  hoistStatics(SelectController, WrappedComponent);
  SelectController.propTypes = WrappedComponent.propTypes;
  SelectController.defaultProps = WrappedComponent.defaultProps;
  SelectController.displayName = name;
  return SelectController;
}

export default selectController;